import { inject } from '@angular/core';
import { EntityBase } from './entity-base';
import { Items } from 'tilby-models';
import { restManager } from 'app/ajs-upgraded-providers';
import { ItemsToUpdate } from 'src/app/features/items/models/items-form.model';

/**
 * Extended EntityBase for Items with additional bulk operations
 */
export class ItemsEntity extends EntityBase<Items> {
    private restService = inject(restManager);

    constructor() {
        super('items');
    }

    /**
     * Bulk update multiple items at once
     * @param items Array of items to update with their UUIDs and fields to modify
     * @returns Promise with the API response
     */
    async bulkUpdateOnline(items: ItemsToUpdate[]): Promise<any> {
        const path = this.entityName;
        return this.restService.post(`${path}/massive_update`, { items });
    }
}
